import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';
import Cookies from 'js-cookie';
import { deleteAuthToken, setAuthToken } from 'common/network/Request';
import { authTokenKey } from 'constants/localStorage';

const cookieKey = 'auth';

// Initialize state from cookies if available
let initialState = {};

if (Cookies.get(cookieKey)) {
  initialState = JSON.parse(Cookies.get(cookieKey));
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action) => {
      const { info, token } = action.payload;
      localStorage.setItem(authTokenKey, token);
      setAuthToken(token);

      Cookies.set(cookieKey, JSON.stringify(action.payload));

      return _.assign({}, state, {
        info,
        token,
      });
    },
    logout: () => {
      localStorage.removeItem(authTokenKey);
      deleteAuthToken();
      Cookies.remove(cookieKey);

      return {};
    },
  },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;
